// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';

import { NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT } from 'Components/widgets/navigation/Navigation.constants';

type Props = {
  children?: Node,
  className?: string,
  closeLabel?: string,
  id?: string,
  onClose?: () => void,
  style?: *,
};

export function NavigationLargeElement(props: Props) {
  const { children, className, closeLabel, id, onClose, style } = props;

  if (!Children.count(children)) {
    return null;
  }

  return (
    <div
      id={id}
      className={classnames(
        className,
        'absolute bg-white overflow-y-auto p-5 rtl:right-0 mt-px top-full',
      )}
      style={{ maxHeight: NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT, ...style }}
    >
      {closeLabel && (
        <button
          className="reset-button a11y-focusable float-right mb-2 px-1 text-blue text-sm"
          onClick={onClose}
          type="button"
        >
          {closeLabel}
        </button>
      )}
      {children}
    </div>
  );
}
